import { render, staticRenderFns } from "./dashboard-counters.vue?vue&type=template&id=a37f48c6&scoped=true"
import script from "./dashboard-counters.vue?vue&type=script&lang=js"
export * from "./dashboard-counters.vue?vue&type=script&lang=js"
import style0 from "./dashboard-counters.vue?vue&type=style&index=0&id=a37f48c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37f48c6",
  null
  
)

export default component.exports